import React, { FC } from 'react'
import { Card, ProgressBar, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { mainColors } from '../../../assets/colors'
import './index.css'

interface Props {
  cardType: string;
  isCertification: boolean;
  progress: number;
  progressTitle: string;
  onSubmit: () => void;
}

const getCardIcon = (cardType: string) => {
  switch (cardType) {
    case 'submitted':
      return <FontAwesomeIcon className='progress-card-icon' icon={['fas', 'exclamation-circle']} color={mainColors.warningBlue} size='2x' />
    case 'rejected':
      return <FontAwesomeIcon className='progress-card-icon' icon={['fas', 'exclamation-circle']} color={mainColors.feedbackRed} size='2x' />
    case 'approved':
      return <FontAwesomeIcon className='progress-card-icon' icon={['fas', 'exclamation-circle']} color={mainColors.successGreen} size='2x' />
    default:
      return null
  }
}

const getCardText = (cardType: string, isCertification: boolean) => {
  switch (cardType) {
    case 'started': 
      return `100%${isCertification ? '' : ' complete' }. Please submit your ${isCertification ? 'certification items' : 'application'}.`
    case 'submitted':
      return `Your ${isCertification ? 'certification items have been submitted and are' : 'application has been submitted and is'} being reviewed.`
    case 'rejected':
      return `Your ${isCertification ? 'certification items have' : 'application has'} been rejected.<br/>Please address the issues below.`
    case 'approved':
      return `Congratulations! <br/> Your ${isCertification ? 'certification items have' : 'application has'} been approved.`
    default:
      return ''
  }
}

const renderCardBody = (cardType: string, isCertification: boolean, progress: number, progressTitle: string, onSubmit: () => void) => {
  const cardText = getCardText(cardType, isCertification)
  const cardIcon = getCardIcon(cardType)

  switch (cardType) {
    case 'started':
      return (
        <Card className='applicant-progress-card progress-card'>
          <Card.Body className='applicant-progress-card-body'>
            <Card.Text className='applicant-card-text progress-card-bold'>
              <span>{cardText}</span>
            </Card.Text>
            <Button variant='info' className='progress-card-btn' onClick={onSubmit}>Submit</Button>
          </Card.Body>
        </Card>
      )
    case 'in progress':
      return (
        <Card className='applicant-progress-card'>
          <Card.Body>
            <Card.Text className='applicant-card-text'>
              <span>{progressTitle}</span><span>{Math.trunc(progress)}%</span>
            </Card.Text>
            <ProgressBar now={progress} />
          </Card.Body>
        </Card>
      )
    case 'submitted':
    case 'rejected':
    case 'approved':
      return (
        <Card className='applicant-progress-card progress-card'>
          <Card.Body className='applicant-progress-card-body'>
            <Card.Text className='applicant-card-text'>
              {cardIcon}
              <span dangerouslySetInnerHTML={{__html: cardText}}/>
            </Card.Text>
          </Card.Body>
        </Card>
      )
    default:
      return null
  }
}

const ProgressCard: FC<Props> = ({ cardType, isCertification, progress, progressTitle, onSubmit }: Props) => {
  return (
    <>
      {renderCardBody(cardType, isCertification, progress, progressTitle, onSubmit)}
    </>
  )
}

export default ProgressCard